import React from 'react';
import './Blogs.css';
import { FaMedium, FaDev } from 'react-icons/fa';
const Blogs: React.FC = () => {
  return (
    <div className="blogs-container">
      <h2 className="blogs-title">✍️ Writing Blogs Is In My Bucket List(:</h2>
      {/* <p className="blogs-intro">A collection of my thoughts and tutorials on software development.</p> */}
      <p className="blogs-intro">Uploading Soon  :) </p>
      <div className="quote">
        <p>IN DEVELOPMENT</p>
      </div>
      {/* <h1> Hii from Sumit </h1> */}
    </div>
  );
};

export default Blogs;
